module.exports = __webpack_public_path__ + "media/PlantAnalytics_OUT.f002459d.mp4";